const apiConfig = {
    APP_ID: 'tra',

    // Member domain
    get memberDomain() { return process.env.VUE_APP_MEMBER },
    get otpRegister() { return `${process.env.VUE_APP_MEMBER}/member/v4/otpRegister` },
    get checkOtpRegister() { return `${process.env.VUE_APP_MEMBER}/member/v4/checkOtpRegister` },
    get otpLogin() { return `${process.env.VUE_APP_MEMBER}/member/v4/otpLogin` },
    get checkOtpLogin() { return `${process.env.VUE_APP_MEMBER}/member/v4/checkOtpLogin` },
    get refreshToken() { return `${process.env.VUE_APP_MEMBER}/member/v4/refreshToken` },
    get logout() { return `${process.env.VUE_APP_MEMBER}/member/v4/logout` },
    get esunWalletSearch() { return `${process.env.VUE_APP_MEMBER}/walletApi/search` },
    get isOverflow() { return `${process.env.VUE_APP_MEMBER}/member/v4/isOverflow` },
    get userApiGet() { return `${process.env.VUE_APP_MEMBER}/userapi/v1/get` },
    get updateMemberTerms() { return `${process.env.VUE_APP_MEMBER}/userapi/v1/updateMemberTerms` },
    get getBirthdayCheck() { return `${process.env.VUE_APP_MEMBER}/userapi/v1/getBirthdayCheck` },
    get updateMember() { return `${process.env.VUE_APP_MEMBER}/userapi/v1/updateMember` },
    get sendFpc() { return `${process.env.VUE_APP_MEMBER}/member/v4/sendFpc` },

    // Common domain
    get commonDomain() { return process.env.VUE_APP_COMMON },
    get checkChannelReferrer() { return `${process.env.VUE_APP_COMMON}/external/v1/checkChannelReferrer` },
    get riskJobList() { return `${process.env.VUE_APP_COMMON}/external/v1/riskJob/list` },
    get addrCityList() { return `${process.env.VUE_APP_COMMON}/external/v1/addrCity/list` },
    get addrZipList() { return `${process.env.VUE_APP_COMMON}/external/v1/addrZip/list` },
    get bankList() { return `${process.env.VUE_APP_COMMON}/external/v1/bank/list` },

    // Travel domain
    get travelDomain() { return process.env.VUE_APP_TRAVEL },
    get getPolicyTypeSwitch() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/getPolicyTypeSwitch` },
    get countryList() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/countryList` },
    get getEffDateTime() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/getEffDateTime` },
    get checkCountPage() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/checkCountPage` },
    get getIndexAmount() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/getIndexAmount` },
    get taiwanPremCalc() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/taiwanPremCalc` },
    get riskCountryList() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/riskCountryList` },
    get getTraveler() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/getTraveler` },
    get addTraveler() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/addTraveler` },
    get delTraveler() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/delTraveler` },
    get checkDetailPage() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/checkDetailPage` },
    get checkContactInfo() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/checkContactInfo` },
    get getKyc() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/getKyc` },
    get checkKYCPage() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/checkKYCPage` },
    get getConfirmPage() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/getConfirmPage` },
    get checkConfirmPage() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/checkConfirmPage` },
    get payOtpSend() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/payOtpSend` },
    get payOtpCheck() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/payOtpCheck` },
    get getTappayKey() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/getTappayKey` },
    get insurancePay() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/insurancePay` },
    get insuranceEbill() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/insuranceEbill` },
    get createPolicyDoc() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/createPolicyDoc` },
    get downloadPolicy() { return `${process.env.VUE_APP_TRAVEL}/download/policy` },
    get getUploadList() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/getUploadList` },
    get uploadPolicy() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/fileUpload` },
    get sendSuccessMail() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/sendSuccessMail` },
    get checkInsuredBirthday() { return `${process.env.VUE_APP_TRAVEL}/insurance/v1/checkInsuredBirthday` },
    get getTravelAtmStatus() { return `${process.env.VUE_APP_TRAVEL}/pageInfo/v1/getTravelAtmStatus` },

    // Clarity domain
    get clarityDomain() { return process.env.VUE_APP_CLARITY },
    get event() { return `${process.env.VUE_APP_CLARITY}/v1/event` },

    // CMS domain
    get CMSDomain() { return process.env.VUE_APP_CMS },

    // QA domain
    get QADomain() { return process.env.VUE_APP_QA },
    get questionsCategory() { return `${process.env.VUE_APP_QA}/QuestionsCategory` },
    get getQuestion() { return `${process.env.VUE_APP_QA}/Questions` },

    // Frontend domain
    get domain() { return process.env.VUE_APP_DOMAIN },
    get survey() { return process.env.VUE_APP_SURVEY },

    // Policy page paths
    get policyOverseas() { return `${process.env.VUE_APP_DOMAIN}/ec/travel/overseas/` },
    get policyTaiwan() { return `${process.env.VUE_APP_DOMAIN}/ec/travel/taiwan/` },
    get policyAccident() { return `${process.env.VUE_APP_DOMAIN}/ec/accident/` },
    get policyCar() { return `${process.env.VUE_APP_DOMAIN}/ec/vehicle/car/` },
    get policyMoto() { return `${process.env.VUE_APP_DOMAIN}/ec/vehicle/motor/` },
    get policyFire() { return `${process.env.VUE_APP_DOMAIN}/ec/house/` },
    get policyCf() { return `${process.env.VUE_APP_DOMAIN}/ec/cf/` },
    get policyMember() { return `${process.env.VUE_APP_DOMAIN}/ec/member/` },
}

export default apiConfig;
